import { Group, Button, TextInput, TextInputProps } from "@mantine/core";
import { useForm, schemaResolver } from "@mantine/form";
import { ContextModalProps } from "@mantine/modals";
import { z } from 'zod';

interface TextInputModalProps {
    initText?: string,
    children?: React.ReactNode;
    textInputProps?: TextInputProps,
    confirmLabel?: string,
    zodString?: z.ZodString,
    onConfirm?: (value: string) => void;
}
export const TextInputModal = ({
    context,
    id,
    innerProps,
}: ContextModalProps<TextInputModalProps>) => {
    const schema = z.object({
        text: innerProps.zodString ?? z.string()
    });
    const form = useForm({
        validate: schemaResolver(schema),
        initialValues: {
            text: innerProps.initText
        },
    });
    return <>
        {innerProps.children}
        <form onSubmit={form.onSubmit((values) => {
            innerProps.onConfirm?.(values.text ?? "");
            context.closeModal(id)
        })}>
            <TextInput
                {...innerProps.textInputProps}
                {...form.getInputProps('text')}
            />
            <Group justify="flex-end" mt="md">
                <Button type="submit">{innerProps.confirmLabel || "確認"}</Button>
            </Group>
        </form>
    </>
}